import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'
import {connect} from 'react-redux'
import {toastr} from 'react-redux-toastr'
import {SubmissionError} from 'redux-form'

import Aperture from 'react-feather/dist/icons/aperture.js'
import Modal from '../../../../shared/components//Modals/Modal.jsx'
import ConfirmModal from '../../../../shared/components/Modals/ConfirmModal/ConfirmModal.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import OfferAnswerForm, {name as formName} from '../../Forms/OfferAnswerForm/OfferAnswerForm.jsx'
import SubmitButton from '../../Forms/OfferAnswerForm/SubmitButton.jsx'

import api from '../../../../api.js'
import conf from '../../../conf.js'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import {isAdmin} from '../../../../shared/services/userService.js'

class OfferAnswerModal extends Modal {
  state = { isConfirmModalOpen: false, isAnalyzing: false }

  isTimeoutError = (e) => e && [408, 504, 524].includes(e.status)

  doDirectAnalysis = async () => {
    this.setState({ isConfirmModalOpen: false, isAnalyzing: true })
    try {
      const response = await api.freelances.ai({ freelance: this.props.freelanceId })
      if (response.data?.status === 'success') {
        sessionStorage.setItem('cv_analysis_pending', JSON.stringify({ analyse: response.data }))
        window.open('/edit/freelance/cv-comparison', '_blank')
      }
    } catch (e) {
      console.warn(e)
      if (this.isTimeoutError(e)) {
        toastr.error(
          'Délai d\'analyse dépassé',
          `Essayez avec un fichier moins volumineux. Si le problème persiste, contactez l'administrateur : ${conf.site.emails.contact}`
        )
        return
      }
      toastr.error('Erreur lors de l\'analyse du CV')
    } finally {
      this.setState({ isAnalyzing: false })
    }
  }
  submit = async (_data) => {
    try {
      const data = {
        ..._data,
        offer: this.props.offer?.id,
        first_name: this.props.answer?.first_name ?? this.props.user?.firstname ?? null,
        tel: this.props.answer?.tel ?? this.props.user?.tel ?? null,
        last_name: this.props.answer?.last_name ?? this.props.user?.lastname ?? null,
        email: this.props.answer?.email ?? this.props.user?.email ?? null,
        cv_id: this.props.answer?.cv?.id ?? this.props.freelance?.cv?.id ?? null,
        type: this.props.answer?.user?.account_type ?? this.props.user?.account_type ?? null,
      }
      if (this.props.isAdmin) {
        data['email'] = _data.user[0].email
        data['user'] = _data.user[0].id
        data['first_name'] = _data.user[0].firstname
        data['last_name'] = _data.user[0].lastname
        data['tel'] = _data.user[0].tel
        data['type'] = _data.user[0].account_type
        let freelance = await api.freelances.getOne({
          freelance: _data.user[0].freelance_id
        })
        data['cvId'] = freelance?.data?.cv ? freelance.data.cv?.id : null
        await api.freelances.edit({
          date_available: data.availability_date,
          freelance: freelance.data?.id,
        })
      } else {
        await api.freelances.edit({
          date_available: data.availability_date,
          freelance: this.props.freelanceId,
        })
      }

      if ((this.props?.answer?.id ?? 0) !== 0) {
        data.offerAnswer = this.props.answer?.id

        return await api.offers.answers.edit(data)
      } else {
        return await api.offers.answers.add(data)
      }
    } catch (e) {
      console.warn(e)
      if (e?.status === 403) {
        toastr.error('Le freelance ne fait pas partie de l\'univers de la mission')
        throw new SubmissionError({})
      }
      throw new SubmissionError(e)
    }
  }

  onFormSuccess = (response) => {
    toastr.success('Votre candidature a bien été reçue par les managers Twineeds')
    if (this.props.onClose) {
      this.props.onClose({
        answer: response.data,
        offset: this.props.offset,
      })
    }
    this.props.closeModal()
  }

  onSubmitFail = (response) => {
    createOnSubmitFailHandler(formName)

    if (response?.data?.errors) {
      for (let i = 0; i < response.data.errors.length; i++) {
        toastr.error(response.data.errors[i].message)
      }
    }
  }

  render() {
    return (
      <>
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} size="lg" backdrop="static">
        <ModalHeader toggle={this.props.closeModal}>Candidater</ModalHeader>
        <ModalBody>
          <div className="callout callout-secondary">
            <p className="mb-2"><strong>Astuce pour maximiser vos chances :</strong></p>
            <p className="mb-2">Un profil complet et régulièrement mis à jour <strong>augmente considérablement l’impact de votre candidature</strong>. Pensez à l’actualiser avant de postuler.</p>

            { !this.props.isAdmin && (
              <>
                { !this.props?.freelance?.cv ? (
                  <a className="btn btn-sm btn-secondary" href="/edit/freelance/mission" target="_blank" rel="noreferrer">
                    Actualiser mon profil
                  </a>
                ) : (
                <div className="d-flex align-items-center">
                  <a className="btn btn-sm btn-outline-secondary" href="/edit/freelance/mission" target="_blank" rel="noreferrer">
                    Actualiser manuellement mon profil
                  </a>

                  <button
                    className="btn btn-sm btn-secondary ml-3"
                    type="button"
                    onClick={() => this.setState({ isConfirmModalOpen: true })}
                  >
                    <Aperture size={14} style={{ marginRight: 6 }} />
                    Analyse intelligente de mon CV
                  </button>
                </div>
                )}
              </>
            )}
          </div>

          { !this.props.isAdmin && !this.props?.freelance?.cv ? (
            <div className="callout callout-danger d-flex gap-2 align-items-center justify-content-between">
              Vous devez télécharger votre CV pour pouvoir répondre à une annonce.
              <a className="btn btn-sm btn-danger" href="/edit/freelance/cv" target="_blank" rel="noreferrer">Ajouter un CV</a>
            </div>
          ) : null }

          <OfferAnswerForm
            isAdmin={this.props.isAdmin}
            enableReinitialize={true}
            initialValues={{
              ...this.props.answer,
              user: this.props.answer && this.props.answer.user ? [this.props.answer.user] : []
            }}
            onSubmit={this.submit}
            onSubmitSuccess={this.onFormSuccess}
            onSubmitFail={this.onSubmitFail}
          />
          <div className="text-center">
            <SubmitButton className="btn btn-primary my-3" disabled={!this.props.isAdmin && !this.props?.freelance?.cv}>
              Candidater
            </SubmitButton>
          </div>
          <Loader visible={this.state.isAnalyzing}>Traitement des données en cours...</Loader>
        </ModalBody>
      </BootstrapModal>

      <ConfirmModal
        isOpen={this.state.isConfirmModalOpen}
        closeModal={() => this.setState({ isConfirmModalOpen: false })}
        header="Analyse intelligente de votre CV"
        body={`<p>
          <strong>Gagnez du temps :</strong> en important votre CV, vous acceptez que son contenu soit <strong>analysé automatiquement par une IA</strong> pour structurer et enrichir votre profil en quelques secondes.
          <ul>
            <li><strong>Confidentialité :</strong> Vos données sont traitées exclusivement en <strong>France</strong> via des solutions sécurisées (<strong>Mistral AI</strong>).</li>
            <li><strong>Éthique :</strong> Aucune revente de données. Utilisation strictement limitée à la création de votre profil.</li>
            <li><strong>Contrôle :</strong> Vous gardez un droit de suppression total à tout moment.</li>
          </ul>
        </p>
        <div class="callout callout-warning">
          <p>L'analyse peut prendre jusqu'à 2 minutes si le fichier contient beaucoup d'informations ou une mise en page particulière.</p>
        </div>`}
        confirmText="J'accepte l'analyse"
        cancelText="Annuler"
        confirmAction={this.doDirectAnalysis}
        onCancel={() => this.setState({ isConfirmModalOpen: false })}
      />
      </>
    )
  }
}

export default connect(
  (state) => ({
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse),
    freelance: state.currentUser?.freelance ?? null,
    freelanceId: state.currentUser?.freelance?.id ?? null
  })
)(OfferAnswerModal)
